import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritContactInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritContactInfo/patchCulpritContactInfoQuery.type';

export const patchCulpritContactInfoFunction = (
  params: PatchCulpritContactInfoQueryParamsType,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/culprit/user_information/driver/contact_information/`,
    params.data,
    {
      params: {
        id: params.id,
      },
    },
  );
};
